let createButton = require('../utility/createButton');
let getStyle     = require('../utility/getStyle');
let getTranslate = require('../utility/getTranslate');

class Carousel {
    /**
     * Create a new carousel
     * @param {string} selector
     * @param {object} config
     * @param {string} [config.type="opacity"]
     * @param {number} [config.index=0] Set current item
     * @param {number} [config.scaleClass='carousel-scale'] Set the class scale for type = size
     * @param {function} [config.nextListener=""]
     * @param {function} [config.prevListener=""]
     */
    constructor(selector, config = {}) {
        this._config = {
            type: 'opacity',
            index: 0,
            scaleClass: 'carousel-scale',
            nextListener: () => {
            },
            prevListener: () => {
            }
        };

        this._container = document.querySelector(selector);
        this._config    = Object.assign({}, this._config, config);

        if (this._checkConfig()) {
            return;
        }

        /*
            Init property
         */
        this._currentIndex = this._config.index;
        this._carousel     = document.createElement('div');
        this._items        = [];
        this._prevArrow    = null;
        this._nextArrow    = null;
        this._currentClass = 'current-element';

        this._createCarousel();

        this._createArrowNavigation();

        this.setPosition(this._currentIndex, window.innerWidth <= 1024);

        this._disableArrow();

        this._createListener();
    }

    _createListener() {
        window.addEventListener('resize', () => {
            this.setPosition(this._currentIndex, window.innerWidth <= 1024);
        });

        this._swipeListener();
    }

    _swipeListener() {
        let currentTranslate  = 0;
        let itemSwitch        = 1;
        let origin            = null;
        let previousTranslate = null;
        let direction         = '';

        // Navigate in swipe
        ['mousedown', 'touchstart'].forEach((listener) => {
            this._carousel.addEventListener(listener, (e) => {
                if (e.touches) {
                    if (e.touches.length > 1) {
                        return
                    } else {
                        e = e.touches[0];
                    }
                }
                
                origin = {
                    x: e.clientX,
                    y: e.clientY
                };

                currentTranslate  = getTranslate(this._carousel)[0];
                itemSwitch        = 1;
                direction         = '';
                previousTranslate = null;
            });
        });
        ['mousemove', 'touchmove'].forEach((listener) => {
            document.addEventListener(listener, (e) => {
                if (origin) {
                    if (listener === 'mousemove') {
                        e.preventDefault();
                    }
                    let point = e.touches ? e.touches[0] : e;
                    
                    if (previousTranslate && direction !== '') {
                        if ((direction === 'left' && point.clientX > previousTranslate.x) || (direction === 'right' && point.clientX < previousTranslate.x)) {
                           origin           = previousTranslate;
                            itemSwitch       = 1;
                            currentTranslate = getTranslate(this._carousel)[0];
                        }
                    }
                    let translate = {
                        x: point.clientX - origin.x,
                        y: point.clientX - origin.y
                    };

                    if (point.clientX > origin.x) {
                        direction = 'right'
                    } else {
                        direction = 'left'
                    }

                    let newTranslate = currentTranslate + translate.x;

                    let currentItemWidth = this._items[this._currentIndex].offsetWidth;
                    if (window.innerWidth <= 768 || this._config.type === 'full') {
                        currentItemWidth /= 2;
                    }

                    this._carousel.style.transform = `translateX(${newTranslate}px)`;

                    if (currentItemWidth > 300) {
                        currentItemWidth = 300;
                    }

                    if (Math.abs(translate.x) >= Math.abs(currentItemWidth * itemSwitch)) {
                        if (translate.x > 0) {
                            if (this._currentIndex - 1 >= 0) {
                                this.prev(false);
                            }
                        } else {
                            if (this._currentIndex + 1 < this._items.length) {
                                this.next(false);
                            }
                        }

                        itemSwitch++;
                    }

                    previousTranslate = point;
                }
            });
        });

        ['mouseup', 'touchend', 'mouseleave'].forEach((listener) => {
            this._carousel.addEventListener(listener, () => {
                if (origin !== null) {
                    origin = null;

                    this.setPosition(this._currentIndex, window.innerWidth <= 1024);
                }
            });
        });
    }

    _createCarousel() {
        this._container.classList.add('carousel');

        while (this._container.children.length > 0) {
            this._container.children[0].setAttribute('tabindex', '-1');
            this._container.children[0].classList.add('carousel-' + this._config.type + '-item');
            if (this._config.type === 'size') {
                this._container.children[0].classList.add('carousel-opacity-item');
            }
            this._carousel.appendChild(this._container.children[0]);
        }

        this._container.classList.add('carousel-' + this._config.type);

        this._items = Array.from(this._carousel.children);

        this._container.append(this._carousel);

        this._items[this._currentIndex].classList.add(this._currentClass);

        this._setStyle();
    }

    _createArrowNavigation() {
        this._prevArrow = createButton('carousel-arrow prev');
        this._nextArrow = createButton('carousel-arrow next');

        this._prevArrow.addEventListener('click', () => {
            if (!this._prevArrow.classList.contains('disable')) {
                this.prev();
            }
        });

        this._nextArrow.addEventListener('click', () => {
            if (!this._nextArrow.classList.contains('disable')) {
                this.next();
            }
        });

        this._container.append(this._prevArrow);
        this._container.append(this._nextArrow);

        if (this._config.type === 'popup') {
            this._prevArrow.classList.add('arrow-popup');
            this._nextArrow.classList.add('arrow-popup');

            let overlay = document.createElement('span');
            let arrow   = document.createElement('span');

            overlay.classList.add('background');
            arrow.classList.add('arrow');

            this._prevArrow.appendChild(overlay.cloneNode(true));
            this._prevArrow.appendChild(arrow.cloneNode(true));
            this._nextArrow.appendChild(overlay);
            this._nextArrow.appendChild(arrow);
        }

        if (this._items.length < 2) {
            this._prevArrow.style.display = 'none';
            this._nextArrow.style.display = 'none';
        }
    }

    _disableArrow() {
        if (this._config.type !== 'popup') {
            if (this._currentIndex === 0) {
                this._prevArrow.classList.add('disable');
            } else {
                this._prevArrow.classList.remove('disable');
            }

            if (this._currentIndex === this._items.length - 1) {
                this._nextArrow.classList.add('disable');
            } else {
                this._nextArrow.classList.remove('disable');
            }
        }
    }

    _setStyle() {
        switch (this._config.type) {
            case 'opacity':
                this._setOpacityStyle();
                break;
            case 'size':
                this._setSizeStyle();
                this._setOpacityStyle();
                break;
            default:
                break;
        }
    }

    _setOpacityStyle() {
        const FIRST  = 0.6;
        const SECOND = 0.2;

        for (let i = 0; i < this._items.length; i++) {
            if (i === this._currentIndex) {
                this._items[this._currentIndex].style.opacity = 1;
            } else if (i === this._currentIndex - 1 || i === this._currentIndex + 1) {
                this._items[i].style.opacity = FIRST;
            } else {
                this._items[i].style.opacity = SECOND;
            }
        }
    }

    _setSizeStyle() {
        for (let item of this._items) {
            item.classList.add(this._config.scaleClass);
        }

        this._items[this._currentIndex].classList.remove(this._config.scaleClass);

        if (this._nextArrow !== null && this._prevArrow !== null) {
            let top     = this._items[this._currentIndex].offsetHeight;
            let prevTop = 0;
            let nextTop = 0;
            if (this._items[this._currentIndex - 1] !== undefined) {
                prevTop = this._items[this._currentIndex - 1].offsetHeight;
            }
            if (this._items[this._currentIndex + 1] !== undefined) {
                nextTop = this._items[this._currentIndex + 1].offsetHeight;
            }

            if ((prevTop !== 0 && Math.abs(prevTop - top) < 70) || (nextTop !== 0 && Math.abs(nextTop - top) < 70)) {
                top -= 10;
            } else {
                top -= 20;
            }

            this._nextArrow.style.top = top + 'px';
            this._prevArrow.style.top = top + 'px';
        }
    }

    setPosition(index, center = false) {
        this._currentIndex = index;

        this._setStyle();

        let currentItem = this._items[this._currentIndex];
        let width       = currentItem.offsetWidth;
        let margin      = getStyle(currentItem, 'margin-left');
        let translate   = 0;
        let transform   = '';

        if (margin === 'auto') {
            margin = 0;
        }

        currentItem.offsetHeight;

        margin = parseInt(margin) * 2;

        if (this._config.type === 'size' || center) {
            let containerWidth = this._container.offsetWidth;
            if (getStyle(this._container, 'box-sizing') !== 'content-box') {
                containerWidth -= parseInt(getStyle(this._container, 'padding-left'));
                containerWidth -= parseInt(getStyle(this._container, 'padding-right'));
            }

            width = this._getWidthFromItem(0);

            translate = Math.ceil((containerWidth / 2) - width);

            transform = `translateX(${translate}px)`;
        } else {
            translate = (width + margin) * this._currentIndex;
            transform = `translateX(-${translate}px)`;
        }

        this._carousel.style.transform = transform;

        this._disableArrow();
    }

    _getWidthFromItem(index, width = 0, end = this._currentIndex) {
        // Get the default margin
        let marginRightCurrentElement = parseInt(getStyle(this._items[index], 'margin-right'));
        let marginLeftCurrentElement  = parseInt(getStyle(this._items[index], 'margin-left'));

        // If this item is the current
        if (index === end) {
            let defaultWidth = this._items[index].offsetWidth;

            // Add the previous width than add all the marge created and the default left marge and the half of the width
            return width + Math.ceil(defaultWidth / 2) + marginLeftCurrentElement;
        } else {
            // Add all marge
            let marge        = Math.floor(marginRightCurrentElement + marginLeftCurrentElement);
            let defaultWidth = this._items[0].offsetWidth;

            return this._getWidthFromItem(index + 1, width + defaultWidth + marge);
        }
    }

    next(position = true) {
        if (this._currentIndex < this._items.length - 1) {
            this._changeCurrentElement(true);
        } else if (this._config.type === 'popup' && this._currentIndex === this._items.length - 1 && position) {
            this.setPosition(0);
        }
    }

    prev(position = true) {
        if (this._currentIndex > 0) {
            this._changeCurrentElement(false);
        } else if (this._config.type === 'popup' && this._currentIndex === 0 && position) {
            this.setPosition(this._items.length - 1);
        }
    }

    _changeCurrentElement(next) {
        this._items[this._currentIndex].classList.remove(this._currentClass);
        const CENTER = window <= 1024;

        if (next) {
            this.setPosition(this._currentIndex + 1, CENTER);
            this._config.nextListener();
        } else {
            this.setPosition(this._currentIndex - 1, CENTER);
            this._config.prevListener();
        }

        this._items[this._currentIndex].classList.add(this._currentClass);
    }

    /**
     * Check if there are an config error
     *
     * @return {boolean}
     * @private
     */
    _checkConfig() {
        let error = false;

        if (this._container === null) {
            console.error('This selector is undefined');
            error = true;
        } else if (this._config.index < 0 && this._config.index >= this._container.children.length) {
            console.error('Index must be between 0 and ' + this._container.children.length - 1);
            error = true;
        }

        if (!['opacity', 'size', 'full', 'popup'].includes(this._config.type)) {
            console.error('Config.type must be set to opacity, size or full actually his value is ' + this._config.type);
            error = true;
        }

        return error;
    }

    getIndex() {
        return this._currentIndex;
    }

    getElements() {
        return this._items;
    }
}

module.exports = Carousel;